/**
 * @generated SignedSource<<8baa082c884df3d2d0f3b8fc723beafe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraNotificationChannelType = "EMAIL" | "IN_PRODUCT" | "MOBILE_PUSH" | "SLACK" | "%future added value";
export type JiraNotificationType = "COMMENT_CREATED" | "COMMENT_DELETED" | "COMMENT_EDITED" | "DAILY_DUE_DATE_NOTIFICATION" | "ISSUE_ASSIGNED" | "ISSUE_CREATED" | "ISSUE_DELETED" | "ISSUE_MOVED" | "ISSUE_UPDATED" | "MENTIONS_COMBINED" | "MISCELLANEOUS_ISSUE_EVENT_COMBINED" | "PROJECT_INVITER_NOTIFICATION" | "WORKLOG_COMBINED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type notificationsConfigRow_personalSettingsNotificationsConfigTable_preference$data = {
  readonly emailChannel: {
    readonly channel: JiraNotificationChannelType | null | undefined;
    readonly isEditable: boolean | null | undefined;
    readonly isEnabled: boolean | null | undefined;
  };
  readonly id: string;
  readonly inProductChannel: {
    readonly channel: JiraNotificationChannelType | null | undefined;
    readonly isEditable: boolean | null | undefined;
    readonly isEnabled: boolean | null | undefined;
  } | null | undefined;
  readonly type: JiraNotificationType;
  readonly " $fragmentType": "notificationsConfigRow_personalSettingsNotificationsConfigTable_preference";
};
export type notificationsConfigRow_personalSettingsNotificationsConfigTable_preference$key = {
  readonly " $data"?: notificationsConfigRow_personalSettingsNotificationsConfigTable_preference$data;
  readonly " $fragmentSpreads": FragmentRefs<"notificationsConfigRow_personalSettingsNotificationsConfigTable_preference">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "channel"
  },
  {
    "kind": "ScalarField",
    "name": "isEnabled"
  },
  {
    "kind": "ScalarField",
    "name": "isEditable"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_preference",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "type"
      },
      "action": "THROW",
      "path": "type"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraNotificationChannel",
        "kind": "LinkedField",
        "name": "emailChannel",
        "plural": false,
        "selections": (v0/*: any*/)
      },
      "action": "THROW",
      "path": "emailChannel"
    },
    {
      "concreteType": "JiraNotificationChannel",
      "kind": "LinkedField",
      "name": "inProductChannel",
      "plural": false,
      "selections": (v0/*: any*/)
    }
  ],
  "type": "JiraNotificationPreference"
};
})();

(node as any).hash = "d84558bbdfdbb5f7d4340d813b2e9bda";

export default node;
